import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchStockOrdersForSelect, useStockOrdersForSelect} from "../../../../redux/stockOrders";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, isLoading, metadata} = useStockOrdersForSelect()

  const handleSearch = search => {
    dispatch(
      fetchStockOrdersForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name="stockOrder"
      label={'STOCK_ORDER'}
      options={data}
      getOptionLabel={option=>option[localField()]}
      onOpen={()=>{
        handleSearch('')
      }}
      onInputChange={(event, search) => {
        handleSearch(search)
      }}
      loading={isLoading}
      {...props}
    />
  )
}